const en = {
  // Shared
  unknownItem: "Unknown item",
  viewPlans: "View plans",
  primary: "Primary",
  makePrimary: "Make primary",
  deleteNamed: "Delete “{name}”?",
  addRate: "Add rate",
  saveRate: "Save rate",
  addRateSummary: "+ Add rate",
  yourRole: "Your role",

  // Shared settings components
  mediaPreviewAlt: "{label} preview",
  mediaCurrentImage: "Current image",
  mediaReplaceImage: "Replace image",
  mediaUploadImage: "Upload image",
  multiSelectSearch: "Search…",
  multiSelectNone: "None selected",
  multiSelectRemove: "Remove {label}",
  multiSelectFilter: "{label}: filter options",
  multiSelectNoMatches: "No matches",
  rateType: "Rate type",
  rateKindFlat: "Flat rate",
  rateKindWeight: "Based on weight",
  rateKindPrice: "Based on order value",
  rateKindFree: "Free shipping",
  rateKindPickup: "Local pickup",
  rateHelpFlat: "One price for every order in this zone.",
  rateHelpWeight: "Applies when the order's total weight falls inside the range.",
  rateHelpPrice: "Applies when the order subtotal falls inside the range.",
  rateHelpFree: "No charge. Set a minimum order value for “free shipping over …”.",
  rateHelpPickup: "Customer collects the order. Optionally charge a handling fee.",
  rateHandlingFee: "Handling fee",
  ratePrice: "Price",
  rateFreeOver: "Free on orders over",
  rateMinOrder: "Minimum order value",
  rateMaxOrder: "Maximum order value",
  rateNoMinimum: "No minimum",
  rateNoMaximum: "No maximum",
  rateMinWeight: "Minimum weight (grams)",
  rateMaxWeight: "Maximum weight (grams)",
  inviteLinkNote: "Email delivery isn't configured on this platform, so share this one-time link with them yourself. It expires in 7 days and only works for the invited email address.",
  inviteRole: "Role",
  inviteSending: "Sending…",
  inviteSend: "Send invite",

  // Store details
  detailsTitle: "Store details",
  detailsDescription: "Basic information about your store, used on your storefront, invoices and emails.",
  detailsGeneral: "General",
  detailsStoreName: "Store name",
  detailsDescriptionHint: "A short summary of what you sell (max 500 characters).",
  detailsContactEmail: "Contact email",
  detailsContactEmailHint: "Shown to customers and used as reply-to for order emails.",
  detailsContactPhone: "Contact phone",
  detailsPlatformAddress: "Platform address: {url}",
  detailsBusinessAddress: "Business address",
  detailsBusinessAddressDesc: "Used on invoices and shown in your store's contact information.",
  detailsLine1: "Address line 1",
  detailsLine2: "Address line 2",
  detailsCity: "City",
  detailsRegion: "Region / state",
  detailsPostalCode: "Postal code",
  detailsCountry: "Country",
  detailsCountryHint: "Your store's home country. Also used for default shipping and tax setup.",
  detailsRegional: "Regional settings",
  detailsStorefrontLanguage: "Storefront language",
  detailsTimezone: "Time zone",
  detailsWeightUnit: "Weight unit",
  detailsUnitKg: "Kilograms (kg)",
  detailsUnitG: "Grams (g)",
  detailsUnitLb: "Pounds (lb)",
  detailsUnitOz: "Ounces (oz)",
  detailsLogoFavicon: "Logo & favicon",
  detailsLogo: "Logo",
  detailsFavicon: "Favicon",
  detailsFaviconHint: "Square image, at least 64×64 px.",
  detailsSearchListing: "Search engine listing",
  detailsSearchListingDesc: "Default title and description for your home page in search results.",
  detailsSeoTitle: "SEO title",
  detailsSeoTitleHint: "Up to 70 characters.",
  detailsMetaDescription: "Meta description",
  detailsMetaDescriptionHint: "Up to 160 characters.",
  detailsNoindex: "Hide my store from search engines",
  detailsNoindexHint: "Adds a noindex directive. Useful while you're still building.",
  detailsSave: "Save store details",
  detailsSaved: "Store details saved",
  currencyTitle: "Currency",
  currencyUses: "Prices and reports use {currency}.",
  currencyChange: "Change currency",
  currencyWarning: "Product prices are not converted. Review your prices after changing the currency.",
  currencyNew: "New currency",
  currencyLocked: "The currency can't be changed after orders have been placed, so your order history stays consistent.",
  currencyChanged: "Store currency changed to {currency}. Review your product prices — amounts were not converted.",
  planUsage: "Plan usage",
  planUsageOn: "You're on the {plan} plan.",
  usageProducts: "Products",
  usageStaff: "Staff accounts",
  usageDomains: "Custom domains",
  usageStorage: "Storage (MB)",
  managePlan: "Manage plan & billing →",
  ownerManagesPlan: "The store owner manages the plan.",

  // Taxes
  taxDescription: "Tax rates applied at checkout.",
  taxDisclaimerTitle: "Tax rates are entered by you",
  taxDisclaimer: "Storelancer applies exactly the rates you set up here. The platform does not determine which taxes apply to your business and does not calculate jurisdictional taxes (such as VAT, GST or US sales tax) automatically. Consult a tax advisor about your obligations.",
  taxCalculation: "Tax calculation",
  taxPricesInclude: "Prices include tax",
  taxPricesIncludeHint: "Common in the EU, UK and Australia. Tax is calculated as part of the price instead of being added at checkout.",
  taxOnShipping: "Charge tax on shipping",
  taxOnShippingHint: "Shipping is taxed using rates marked “applies to shipping”.",
  taxRates: "Tax rates",
  taxRatesDesc: "Rates for the customer's country apply to every address there; region rates are added on top for addresses in that region. Matching rates are added together.",
  taxNoRates: "No tax rates",
  taxNoRatesDesc: "Without tax rates, no tax is charged at checkout.",
  taxColLocation: "Location",
  taxColRate: "Rate",
  taxColClass: "Class",
  taxColShipping: "Shipping",
  taxAllProducts: "All products",
  taxEditRate: "Edit {name} ({location})",
  taxAddRate: "+ Add tax rate",
  taxNameHint: "Shown on receipts, e.g. “VAT”.",
  taxRegionCode: "Region code",
  taxRegionCodeHint: "e.g. CA for California. Empty = whole country.",
  taxRatePercent: "Rate (%)",
  taxRatePercentHint: "Up to two decimals.",
  taxClass: "Tax class",
  taxClassHint: "Only applies to products with this tax class. Empty = all taxable products (and shipping).",
  taxAppliesToShipping: "Applies to shipping",
  taxAppliesToShippingHint: "Used only when “Charge tax on shipping” is on.",
  taxSettingsSaved: "Tax settings saved",
  taxUnknownRate: "Unknown tax rate",
  taxInvalidPercent: "Enter a percentage with at most two decimals, e.g. 20 or 7.25.",
  taxInvalidPercentField: "Invalid percentage",
  taxRateUpdated: "Tax rate updated",
  taxRateAdded: "Tax rate added",
  taxRateDeleted: "Tax rate deleted",

  // Checkout
  checkoutDescription: "Control what customers need to provide when they place an order.",
  checkoutCustomerInfo: "Customer information",
  checkoutGuest: "Allow guest checkout",
  checkoutGuestHint: "Customers can order without creating an account. Turning this off requires an account for every order, which usually lowers conversion.",
  checkoutPhone: "Require a phone number",
  checkoutPhoneHint: "Useful for couriers and cash on delivery.",
  checkoutTerms: "Require acceptance of terms",
  checkoutTermsHint: "Customers must tick a box agreeing to your terms and policies. Edit them under {pages}.",
  checkoutNotes: "Allow order notes",
  checkoutNotesHint: "Customers can add a note for you (e.g. delivery instructions).",
  checkoutReservation: "Stock reservation for online payments",
  checkoutReservationText: "When a customer is sent to an online payment page (Stripe, PayPal), the items are held for them so they can't sell out mid-payment. If payment isn't completed within this time, the order expires and the stock is released. Offline methods (cash on delivery, bank transfer) keep stock reserved until you cancel or mark the order paid.",
  checkoutReservationTime: "Reservation time (minutes)",
  checkoutReservationHint: "Between 10 and 1440 minutes (24 hours). 30 minutes suits most stores.",
  checkoutSave: "Save checkout settings",
  checkoutSaved: "Checkout settings saved",

  // SEO
  seoDescription: "Help search engines find your store and keep old links working.",
  seoSearchEngines: "Search engines",
  seoSitemapText: "Your store automatically publishes a sitemap and robots file. Submit the sitemap in Google Search Console or Bing Webmaster Tools.",
  seoStoreWideText: "Store-wide title, description and “hide from search engines” are in {link}. Products, collections and pages have their own SEO fields in their editors. Unpublished stores aren't indexed.",
  seoRedirects: "URL redirects",
  seoRedirectsDesc: "Send visitors (and search engines) from an old path to a new location with a permanent (301) redirect. Redirects apply only when the old path no longer exists on your store.",
  seoFromPath: "From path",
  seoFromPathHint: "A path on your store, e.g. /old-sale",
  seoTo: "To",
  seoToHint: "A path, e.g. /products/new-item, or an https:// URL",
  seoAddRedirect: "Add redirect",
  seoNoRedirects: "No redirects",
  seoNoRedirectsDesc: "Add one when you rename a product, collection or page so old links keep working.",
  seoColFrom: "From",
  seoColTo: "To",
  seoDeleteRedirect: "Delete redirect?",
  seoDeleteRedirectBody: "{path} will no longer redirect.",
  seoRedirectSaved: "Redirect saved",
  seoRedirectDeleted: "Redirect deleted",
  seoUnknownRedirect: "Unknown redirect",

  // Shipping
  shipDescription: "Where you ship and what customers pay for delivery.",
  shipHowTitle: "How shipping is matched",
  shipHow1: "At checkout the customer's country (and postal code, if a zone lists prefixes) picks the zone. A zone that names the country is preferred over “Rest of world”.",
  shipHow2: "Every active rate in that zone whose conditions match the cart (order value, weight) is offered — the customer chooses one.",
  shipHow3: "If no zone or rate matches, the customer can't check out with items that need shipping. Digital products and services never need shipping.",
  shipNoActiveRate: "You sell physical products but have no active shipping rate — customers can't complete checkout.",
  shipNoZones: "No shipping zones yet",
  shipNoZonesDesc: "Create a zone for {country} (or everywhere you ship) and add at least one rate.",
  shipNoZonesAction: "Use “Add shipping zone” below.",
  shipAddZone: "Add shipping zone",
  shipRestOfWorld: "Rest of world",
  shipKindFlat: "Flat rate",
  shipKindWeight: "By weight",
  shipKindPrice: "By order value",
  shipKindFree: "Free shipping",
  shipKindPickup: "Local pickup",
  shipZoneName: "Zone name",
  shipZoneNameHint: "Only you see this, e.g. “Domestic” or “Europe”.",
  shipCountries: "Countries",
  shipCountriesHint: "Choose “Rest of world” to cover every country not listed in another zone.",
  shipPostalPrefixes: "Postal code prefixes",
  shipPostalPrefixesHint: "Limit the zone to postal codes starting with these values, separated by commas or new lines (e.g. 75, 92, 93). Leave empty for the whole country.",
  shipSaveZone: "Save zone",
  shipCreateZone: "Create zone",
  shipRateName: "Rate name",
  shipRateNameHint: "Shown to customers at checkout.",
  shipRateNamePlaceholder: "Standard shipping",
  shipDeliveryEstimate: "Delivery estimate",
  shipDeliveryEstimatePlaceholder: "2–4 business days",
  shipActive: "Active",
  shipActiveHint: "Inactive rates are never offered at checkout.",
  shipOrdersBetween: "Orders {min}–{max}",
  shipOrdersOver: "Orders over {min}",
  shipOrdersUpTo: "Orders up to {max}",
  shipWeightRange: "{min} g – {max}",
  shipWeightGrams: "{value} g",
  shipWeightAny: "any",
  shipCountriesMore: "{list} and {count} more",
  shipPostalStarting: "Postal codes starting with: {prefixes}",
  shipDeleteZone: "Delete zone",
  shipDeleteZoneBody: "The zone and its {count} rates will be removed. Customers in these countries won't be able to choose these rates.",
  shipDeleteZoneBody_one: "The zone and its {count} rate will be removed. Customers in these countries won't be able to choose these rates.",
  shipNoRates: "No rates yet — customers in this zone can't check out with physical items.",
  shipInactive: "Inactive",
  shipNoConditions: "No conditions",
  shipFree: "Free",
  shipDeleteRate: "Delete rate",
  shipEditRate: "Edit rate",
  shipEditZone: "Edit zone",
  shipZoneUpdated: "Zone updated",
  shipZoneCreated: "Zone created — now add a rate to it.",
  shipZoneDeleted: "Zone deleted",
  shipRateUpdated: "Rate updated",
  shipRateAdded: "Rate added",
  shipRateDeleted: "Rate deleted",

  // Domains
  domainDescription: "Use your own domain name for your storefront.",
  domainStatusPending: "Pending verification",
  domainStatusVerified: "Verified",
  domainStatusFailed: "Verification failed",
  domainSslPending: "SSL pending",
  domainSslActive: "SSL active",
  domainSslFailed: "SSL failed",
  domainSslUnknown: "SSL unknown",
  domainPlatformAddress: "Platform address",
  domainPlatformAddressDesc: "Always available, free, with HTTPS included.",
  domainConnect: "Connect a domain",
  domainUsage: "{used} of {count} custom domains used on the {plan} plan.",
  domainUsage_one: "{used} of {count} custom domain used on the {plan} plan.",
  domainNotIncluded: "Custom domains aren't included in the {plan} plan",
  domainUpgrade: "Upgrade your plan to connect a domain you own.",
  domainAtLimit: "You've reached your plan's domain limit. Remove a domain or upgrade to add another.",
  domainField: "Domain",
  domainFieldHint: "e.g. shop.example.com or example.com — you must own it.",
  domainAdd: "Add domain",
  domainNone: "No custom domains",
  domainNoneDesc: "Your store is reachable at its platform address.",
  domainLastChecked: "Last checked: {date}",
  domainChecking: "Checking…",
  domainCheckNow: "Check now",
  domainRemoveTitle: "Remove {host}?",
  domainRemove: "Remove domain",
  domainRemovePrimaryBody: "This is your primary domain. Your store will switch back to the platform address. Remember to remove the DNS records at your registrar.",
  domainRemoveBody: "Visitors to this domain will no longer reach your store. Remember to remove the DNS records at your registrar.",
  domainDnsIntro: "Add these records at your domain registrar or DNS provider. Changes can take from a few minutes up to 48 hours to propagate.",
  domainVerifyOwnership: "Verify ownership",
  domainPointToStore: "Point the domain to your store",
  domainRootNote: "Root domains can't use CNAME at most providers. Use an ALIAS/ANAME (or the A record value shown) — or connect a subdomain like www or shop instead.",
  domainRedirecting: "Visitors to this domain are redirected to your primary domain.",
  domainServing: "This domain serves the store directly (no redirect).",
  domainStopRedirect: "Stop redirecting",
  domainRedirectToPrimary: "Redirect to primary",
  domainDnsType: "Type",
  domainDnsName: "Name / host",
  domainDnsValue: "Value",
  domainUnknown: "Unknown domain",
  domainAdded: "{host} added. Create the DNS records below, then choose “Check now”.",
  domainVerifiedHttps: "Verified — HTTPS is active.",
  domainVerifiedPendingSsl: "Verified. HTTPS certificate is still being issued.",
  domainCheckedFailed: "Checked just now — verification failed.",
  domainCheckedPending: "Checked just now — still pending.",
  domainPrimaryUpdated: "Primary domain updated",
  domainPlatformPrimary: "The platform address is now primary",
  domainRemoved: "Domain removed",

  // Payments
  payDescription: "Connect your own payment accounts. Money from your customers goes directly to the accounts you connect here.",
  payStripeConnectedTitle: "Stripe account connected",
  payStripeConnectedBody: "Run a connection test, then enable Stripe in checkout.",
  payStripeErrorTitle: "Stripe connection not completed",
  payStripeErrorBody: "The connection attempt could not be completed. Please try again.",
  payCustomersSee: "Customers currently see at checkout:",
  payTestModeWarning: "A method in test mode can't take real payments. Switch to live credentials before launch.",
  payNoneEnabledTitle: "Customers can't check out until you enable a payment method.",
  payNoneEnabledBody: "Connect an online provider or set up cash on delivery / bank transfer, then choose “Enable in checkout”.",
  payOwnAccountsNote: "Each store uses only the payment accounts connected on this page. Storelancer never processes your store's orders through a platform account and there is no fallback account — if nothing is enabled, checkout is unavailable. Processing fees are charged by your provider.",
  payProblemTitle: "Payment connection problem",
  payProblemBody: "{providers} need attention. Methods that fail a connection test are removed from checkout automatically.",
  payProblemBody_one: "{providers} needs attention. Methods that fail a connection test are removed from checkout automatically.",
  payProviders: "Payment providers",
  payComingLater: "Coming later",
  payComingLaterDesc: "These providers are not yet supported and can't be connected. They're listed so you know what's planned.",
  payCheckoutSettingsNote: "Need to set which customers can check out as guests or how long stock is reserved during online payment? See {link}.",
  payCheckoutSettingsLink: "checkout settings",
  payState_not_connected: "Not connected",
  payState_setup_required: "Setup required",
  payState_connected: "Connected · not enabled",
  payState_test_mode: "Active in checkout · Test mode",
  payState_active: "Active in checkout",
  payState_connection_problem: "Connection problem",
  payState_reauth_required: "Reauthorization required",
  payState_unavailable: "Temporarily unavailable",
  payState_not_supported: "Not yet supported",
  providerName_cod: "Cash on delivery",
  providerName_bank_transfer: "Bank transfer",
  providerDesc_stripe: "Cards, wallets and local methods via Stripe-hosted Checkout. Payments settle to your own Stripe account.",
  providerDesc_paypal: "PayPal wallet checkout using your own PayPal business REST app credentials.",
  providerDesc_cod: "Customer pays the courier or you in person. You confirm payment manually.",
  providerDesc_bank_transfer: "Show your bank details after checkout. You mark the order paid once funds arrive.",
  providerDescNotSupported: "Not yet supported. The adapter interface is ready for this integration, but it isn't implemented, so it can't be connected.",
  providerRegions_stripe: "Available in 45+ countries — check Stripe's list for your business location.",
  providerRegions_paypal: "Available in 200+ markets; currency support varies.",
  providerRegions_cod: "Anywhere you can collect payment on delivery.",
  providerRegions_bank_transfer: "Anywhere.",
  providerMethods_stripe: "Cards, Apple Pay, Google Pay, local methods enabled in your Stripe dashboard",
  providerMethods_paypal: "PayPal wallet, Pay Later / cards where PayPal offers them",
  providerMethods_cod: "Cash or card on delivery",
  providerMethods_bank_transfer: "Manual bank transfer",
  payModeLive: "Live",
  payModeTest: "Test",
  payDocs: "Docs ↗",
  payDocsSr: " for {name} (opens in a new tab)",
  payMethods: "Payment methods",
  payRegions: "Regions",
  payAccount: "Account",
  payViaConnect: " · via Stripe Connect",
  payViaKeys: " · via API keys",
  payLastVerified: "Last verified",
  payCredentials: "Credentials",
  payCredentialsSaved: "Credentials saved (encrypted, never shown again)",
  payUnavailableTitle: "{name} is temporarily unavailable on this platform",
  payUnavailableDefault: "The platform has paused new connections and checkout for this provider.",
  paySettingsKept: "Existing settings are kept.",
  payLastErrorTitle: "Last error from the provider",
  payReauth: "The provider no longer accepts this authorization. Reconnect the account below.",
  payMissingConfig: "Missing configuration",
  payStripeKeysIntro: "In your Stripe dashboard open {path} and create a {restricted} (recommended) or copy your secret key. Keys are verified with Stripe, then encrypted. They are never displayed again.",
  payStripeKeysPath: "Developers → API keys",
  payStripeRestrictedKey: "restricted key",
  payStripeSecretKey: "Secret or restricted key",
  payStripeSecretKeyHint: "Starts with sk_test_, sk_live_, rk_test_ or rk_live_. Test keys create test-mode payments only.",
  payWebhookSigningSecret: "Webhook signing secret",
  payWebhookSigningSecretHint: "Starts with whsec_. You can add it after creating the webhook endpoint below.",
  payVerifyingStripe: "Verifying with Stripe…",
  payReplaceApiKey: "Replace API key",
  payVerifySaveKey: "Verify and save key",
  payReconnectStripe: "Reconnect with Stripe",
  payConnectStripe: "Connect with Stripe",
  payStripeOauthNote: "You'll sign in to Stripe and authorize this store. Payments settle directly to your Stripe account.",
  payStripeOauthUnavailable: "One-click Stripe Connect isn't configured on this platform. Connect your own Stripe account with an API key instead.",
  payUseApiKeys: "Use API keys instead",
  payStripeConnectNote: "Connected through Stripe Connect. Payment events are delivered to the platform's Connect webhook and routed to this store automatically.",
  payPaypalIntro: "Create a REST app at {path} using your PayPal {business} account, then paste its credentials. They're verified with PayPal and stored encrypted.",
  payPaypalPath: "developer.paypal.com → Apps & Credentials",
  payPaypalBusiness: "business",
  payClientId: "Client ID",
  payClientSecret: "Client secret",
  payEnvironment: "Environment",
  payEnvironmentHint: "Sandbox is for testing — no real money moves.",
  paySandbox: "Sandbox (test)",
  payLive: "Live",
  payWebhookId: "Webhook ID",
  payWebhookIdHint: "From the webhook you create in your PayPal app.",
  payVerifyingPaypal: "Verifying with PayPal…",
  payReplaceCredentials: "Replace credentials",
  payVerifySave: "Verify and save",
  payWebhook: "Webhook",
  paySigningSecretSaved: "Signing secret saved",
  payWebhookIdSaved: "Webhook ID saved",
  payNotConfigured: "Not configured",
  payStripeWebhookIntro: "In Stripe open {path}, paste this URL and select the events below. Then copy the endpoint's signing secret here.",
  payStripeWebhookPath: "Developers → Webhooks → Add endpoint",
  payPaypalWebhookIntro: "In your PayPal app add a webhook with this URL and the events below. Then paste the webhook ID here.",
  payCopyUrl: "Copy URL",
  payEventsToEnable: "Events to enable",
  payReplaceSigningSecret: "Replace signing secret",
  paySigningSecret: "Signing secret",
  payReplaceWebhookId: "Replace webhook ID",
  payWebhookIdPlaceholder: "e.g. 8PT597110X687430LKGECATA",
  payNameAtCheckout: "Name shown at checkout",
  payDefaultsTo: "Defaults to “{name}”.",
  payBankDetails: "Bank details and instructions",
  payBankDetailsHint: "Shown to customers after they place an order and in their confirmation email. Include account holder, IBAN/account number, bank name and the reference to use (e.g. the order number).",
  paySetUp: "Set up {name}",
  payEditSettings: "Edit settings",
  payDisabling: "Disabling…",
  payDisable: "Disable in checkout",
  payEnabling: "Enabling…",
  payEnable: "Enable in checkout",
  payTesting: "Testing…",
  payTestConnection: "Test connection",
  payDisconnectTitle: "Disconnect {name}?",
  payDisconnect: "Disconnect",
  payDisconnectBody: "Customers will no longer see {name} at checkout.",
  payDisconnectBodyCredentials: "Customers will no longer see {name} at checkout and the saved credentials will be deleted.",
  payDisconnectInProgress: "If customers have checkouts in progress with this provider, disconnecting is blocked until they complete or expire.",
  payDisconnectRefunds: "Refunds for past orders paid with {name} need the same account connected again — or can be issued from the provider's own dashboard.",
  payEnabledNote: "Customers can choose this method at checkout (subject to the rules below).",
  payDisabledNote: "Not shown to customers until you enable it.",
  payRulesSummary: "Checkout rules (currencies, countries, order amount)",
  payRulesIntro: "Limit when this method is offered. Leave a rule empty to allow everything.",
  payCurrencies: "Currencies",
  payAllCurrencies: "All currencies",
  payStoreSellsIn: "Your store sells in {currency}.",
  payCustomerCountries: "Customer countries",
  payAllCountries: "All countries",
  payCountriesHint: "Based on the customer's shipping/billing country.",
  payMinAmount: "Minimum order amount",
  payMaxAmount: "Maximum order amount",
  paySaveRules: "Save rules",
  payUnknownConnection: "Unknown payment connection",
  payUnknownMethod: "Unknown method",
  payStripeSaved: "Stripe credentials verified and saved (live mode). Next: add the webhook below, run a connection test, then enable Stripe in checkout.",
  payStripeSavedTest: "Stripe credentials verified and saved (test mode). Next: add the webhook below, run a connection test, then enable Stripe in checkout.",
  payPaypalSaved: "PayPal credentials verified and saved (live). Enable PayPal in checkout when you're ready.",
  payPaypalSavedSandbox: "PayPal credentials verified and saved (sandbox). Enable PayPal in checkout when you're ready.",
  payOfflineSaved: "{name} saved. Turn it on with “Enable in checkout”.",
  payOfflineEnabled: "{name} is now offered at checkout.",
  payTestFailed: "Connection test failed: {reason}. This method has been removed from checkout until a test succeeds.",
  payTestFailedDefault: "the provider rejected the request",
  payTestOkLive: "Connection OK{account} (live mode).",
  payTestOkTest: "Connection OK{account} (test mode).",
  payEnabledInCheckout: "Enabled in checkout",
  payRemovedFromCheckout: "Removed from checkout",
  payMaxBelowMin: "The maximum order amount must be at least the minimum.",
  payMaxBelowMinField: "Must be at least the minimum",
  payRulesSaved: "Checkout rules saved",
  payDisconnected: "Disconnected. Stored credentials were deleted.",
  payPasteValue: "Paste the value from your provider's dashboard.",
  payWebhookSaved: "Webhook setting saved",

  // Team
  teamDescription: "People who can help manage this store, and what each of them can do.",
  teamInvite: "Invite someone",
  teamSeats: "{used} of {count} staff accounts used on the {plan} plan (the owner isn't counted).",
  teamSeats_one: "{used} of {count} staff account used on the {plan} plan (the owner isn't counted).",
  teamNotIncluded: "Team accounts aren't included in the {plan} plan",
  teamUpgrade: "Upgrade to invite staff.",
  teamOnlyOwnerAdmins: "Only the store owner can invite administrators.",
  teamMembers: "Members",
  teamMemberCount: "{count} members",
  teamMemberCount_one: "{count} member",
  teamYou: "(you)",
  teamRoleFor: "Role for {email}",
  teamRemoveTitle: "Remove {name}?",
  teamRemoveBody: "They'll lose access to this store immediately. Their past actions stay in the activity log.",
  teamPendingInvites: "Pending invitations",
  teamExpires: "{role} · expires {date}",
  teamRevokeTitle: "Revoke invitation for {email}?",
  teamRevoke: "Revoke",
  teamRolesTitle: "Roles and permissions",
  teamRolesDesc: "Payments, refunds and team access are limited to the roles below. The server enforces these on every action.",
  teamRoleDesc_owner: "Full access, including billing, payments and publishing. Can't be removed.",
  teamRoleDesc_admin: "Everything except billing: products, orders and refunds, payments, domains, team and publishing.",
  teamRoleDesc_product_manager: "Products, collections, inventory, the store builder and pages. Can view analytics.",
  teamRoleDesc_order_manager: "Orders (including refunds and fulfillment), inventory and shipping settings. Can view customers.",
  teamRoleDesc_support: "View orders and manage customers. No refunds or settings.",
  teamRoleDesc_analyst: "Read-only access to orders, customers and analytics.",
  teamUnknownMember: "Unknown team member",
  teamInviteEmailed: "Invitation emailed to {email}.",
  teamInviteCreated: "Invitation created for {email}.",
  teamInviteRevoked: "Invitation revoked",
  teamRoleUpdated: "Role updated",
  teamMemberRemoved: "Member removed",
};

export default en;
